/**
 * Org invites resource — typed wrappers over the invite endpoints
 * (multi-tenancy Phase D). create/list/revoke are admin-only + active-org
 * scoped; accept is for any authenticated user (joining via an emailed link).
 */

import { api } from "@/lib/api-client";
import type { Paginated } from "./types";

/** Mirrors orgs.Invite (the token is never returned in list responses). */
export interface Invite {
  id: string;
  org_id: string;
  email: string;
  role: string;
  status: string;
  created_at: string;
  expires_at: string;
}

/** Mirrors orgs.OrgRef returned by accept. */
export interface AcceptedOrg {
  id: string;
  slug: string;
  name: string;
  role: string;
}

export const invitesApi = {
  list: (orgId: string) =>
    api.get<Paginated<Invite>>(`/v1/platform/orgs/${orgId}/invites`),
  create: (orgId: string, body: { email: string; role: string }) =>
    api.post<{ invite: Invite; link: string }>(
      `/v1/platform/orgs/${orgId}/invites`,
      body,
    ),
  revoke: (orgId: string, inviteId: string) =>
    api.delete<void>(`/v1/platform/orgs/${orgId}/invites/${inviteId}`),
  accept: (token: string) =>
    api.post<AcceptedOrg>(`/v1/platform/invites/${token}/accept`),
};
